import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {IBreadCrumb} from './breadcrumb.interface';
import {distinctUntilChanged, filter} from 'rxjs/operators';
import {SharingDataService} from 'src/app/services/sharing-data.service';
import {AppConfig} from 'src/app/services/AppConfig';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
    public breadcrumbs: IBreadCrumb[];
    colorBread: string = '';


    constructor(
        private appConf: AppConfig,
        private router: Router,
        private sharing: SharingDataService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
    }

    ngOnInit() {
        const IS_ENV_TEST = !environment.production;
        this.colorBread = !IS_ENV_TEST ? '#448AFF' : '#D8730D';
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            distinctUntilChanged(),
        ).subscribe(() => {
            this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
        });
    }

    /**
     * Recursively build breadcrumb according to activated route.
     * @GfxListActParam route
     * @GfxListActParam url
     * @GfxListActParam breadcrumbs
     */
    buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {
        //If no routeConfig is avalailable we are on the root path
        let label = route.routeConfig && route.routeConfig.data ? route.routeConfig.data.breadcrumb : '';
        let isClickable = route.routeConfig && route.routeConfig.data && route.routeConfig.data.isClickable;
        let path = route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

        // If the route is dynamic route such as ':id', remove it
        const lastRoutePart = path.split('/').pop();
        const isDynamicRoute = lastRoutePart.startsWith(':');
        if (isDynamicRoute && !!route.snapshot) {
            const paramName = lastRoutePart.split(':')[1];
            path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
            label = route.snapshot.params[paramName];
        }

        //In the routeConfig the complete path is not available,
        //so we rebuild it each time
        const nextUrl = path ? `${url}/${path}` : url;

        const breadcrumb: IBreadCrumb = {
            label: label,
            url: nextUrl,
        };
        // Only adding route with non-empty label
        const newBreadcrumbs = breadcrumb.label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];
        if (route.firstChild) {
            //If we are not on our current path yet,
            //there will be more children to look after, to build our breadcumb
            return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
        }
        return newBreadcrumbs;
    }

    onBreadcrumbClick(breadcrumb) {
        this.sharing.changeBreadCrumb(breadcrumb);
    }
}
